import React from 'react';

const EmailCloud = () => {
  return (
    <svg
      width="933"
      height="654"
      viewBox="0 0 933 654"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M929.4 343.7C929.4 235 841.3 146.9 732.6 146.9C719.6 146.9 706.8 148.2 694.5 150.6C648.2 74.7 564.7 24 469.3 24C374.6 24 291.5 74 245.1 149.1C235.6 147.7 225.8 146.9 215.9 146.9C107.2 146.9 19.1 235 19.1 343.7C19.1 444 94.2 526.8 191.2 539C214.2 605.9 277.7 654 352.5 654C401.2 654 445.1 633.6 476.2 600.9C507.3 633.6 551.2 654 599.9 654C674.8 654 738.5 605.7 761.3 538.5C856.3 524.7 929.4 442.7 929.4 343.7Z"
        fill="black"
      />
      <path
        d="M929 323.7C929 215 839.487 126.9 729.044 126.9C715.835 126.9 702.83 128.2 690.333 130.6C643.29 54.7 558.451 4 461.521 4C365.303 4 280.87 54 233.726 129.1C224.074 127.7 214.116 126.9 204.058 126.9C93.5128 126.9 4 215 4 323.7C4 424 80.3044 506.8 178.86 519C202.229 585.9 266.747 634 342.747 634C392.228 634 436.832 613.6 468.43 580.9C500.029 613.6 544.633 634 594.114 634C670.215 634 734.937 585.7 758.103 518.5C854.728 504.7 929 422.7 929 323.7Z"
        fill="#FFE0E0"
        stroke="black"
        strokeWidth="7"
        strokeMiterlimit="10"
      />
      <path
        d="M300 130C308.284 130 315 123.284 315 115C315 106.716 308.284 100 300 100C291.716 100 285 106.716 285 115C285 123.284 291.716 130 300 130Z"
        fill="black"
      />
      <path
        d="M295.5 114C297.985 114 300 111.985 300 109.5C300 107.015 297.985 105 295.5 105C293.015 105 291 107.015 291 109.5C291 111.985 293.015 114 295.5 114Z"
        fill="white"
      />
      <path
        d="M583 130C591.284 130 598 123.284 598 115C598 106.716 591.284 100 583 100C574.716 100 568 106.716 568 115C568 123.284 574.716 130 583 130Z"
        fill="black"
      />
      <path
        d="M578.5 114C580.985 114 583 111.985 583 109.5C583 107.015 580.985 105 578.5 105C576.015 105 574 107.015 574 109.5C574 111.985 576.015 114 578.5 114Z"
        fill="white"
      />
    </svg>
  );
};

export default EmailCloud;
